export default "__VITE_ASSET__h_7_CGqm__";